import { render, staticRenderFns } from "./OptinRequest.vue?vue&type=template&id=275f0ea4&scoped=true"
import script from "./OptinRequest.vue?vue&type=script&lang=js"
export * from "./OptinRequest.vue?vue&type=script&lang=js"
import style0 from "./OptinRequest.vue?vue&type=style&index=0&id=275f0ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f0ea4",
  null
  
)

export default component.exports